import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Router } from '@angular/router';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Badge } from '@capawesome/capacitor-badge';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Browser } from '@capacitor/browser';
import { AnalyticsService } from './analytics.service';

@Injectable({
  providedIn: 'root'
})
export class PushService {
  public hasPermission: boolean = false;
  public token: string = "";
  public message: any;

  constructor(
    private platform: Platform,
    // public fireMessaging: AngularFireMessaging, // Temporarily disabled
    //public fbx: FirebaseX,
    public router: Router,
    public browser: InAppBrowser,
    public analyticsService: AnalyticsService
  ) {}

  public async init() {
      try {
        //this.webPermission();
        if(await this.checkPermission() && this.platform.is('capacitor') && this.platform.is('cordova'))
        {
          await Badge.clear();
          await Badge.set({count: 0});
        }
        console.log("PUSH STATUS: " + (await FirebaseMessaging.checkPermissions()).receive)
        if(await this.checkPermission())
        {
          await this.initPush();
        }
      } catch (error) {
        console.error('Push service initialization failed:', error);
        // Continue without push notifications if Firebase is not ready
      }
  }

  public async initPush()
  {
    try {
      if(this.platform.is("capacitor") || this.platform.is("cordova"))
      {
        this.token = (await FirebaseMessaging.getToken()).token;
        localStorage.setItem("pushToken", this.token);
        await this.onMessageReceived();
        console.log("PUSH TOKEN: " + this.token);
        LocalNotifications.addListener('localNotificationActionPerformed', (notification) => {
          console.log('PUSH NOTIFICATION DATA: ', notification);
          if(notification.notification.extra.action == "workout")
          {
            this.router.navigateByUrl("workout");
          }
        });
      }
      else {
        //this.token = (await this.fireMessaging.getToken.toPromise())!;
      }
    } catch (error) {
      console.error('Push initialization failed:', error);
      // Continue without push notifications if Firebase is not ready
    }
  }

  public webPermission() {
    // Note: AngularFire Messaging temporarily disabled due to initialization issues
    console.log("Web permission temporarily disabled - using direct Firebase Messaging");
    localStorage.setItem("pushToken", this.token);
  }

  public async requestPermission() {
    try {
      if (this.platform.is('capacitor') && (await FirebaseMessaging.checkPermissions()).receive != 'granted') {
        let status = await FirebaseMessaging.requestPermissions();
        await this.initPush();
        await this.analyticsService.trackEvent("Set Push Permission", {status: status.receive});
      }
      else {
        this.webPermission();
      }
    } catch (error) {
      console.error('Request permission failed:', error);
    }
  }

  public async checkPermission() {
    try {
      return (this.platform.is('capacitor') && (await FirebaseMessaging.checkPermissions()).receive == 'granted');
    } catch (error) {
      console.error('Check permission failed:', error);
      return false;
    }
  }

  public async getToken() {
    try {
      return (await FirebaseMessaging.getToken()).token;
    } catch (error) {
      console.error('Get token failed:', error);
      return '';
    }
  }
  
  private async onMessageReceived() {
    try {
      if(this.platform.is("capacitor") || this.platform.is("cordova"))
      {
        await FirebaseMessaging.addListener('notificationReceived', (message) => {
          console.log('PUSH NOTIFICATION DATA: ', message);
        });

        await FirebaseMessaging.addListener('notificationActionPerformed', event => {
          console.log('notificationActionPerformed', { event });
          this.handleAction(event);
        });
      }
      else {
        /*this.fireMessaging.messages.pipe(take(1)).subscribe(
          (message) => this.handleAction(message),
          (error) => console.error("Error receiving message", error)
        );*/
      }
    } catch (error) {
      console.error('Message listener setup failed:', error);
    }
  }

  public async handleAction(message: any)
  {
    if(message.notification.data.url.includes("grammario.de"))
    {
      //this.browser.create(data.url, "_blank", "toolbarposition=top,location=no,fullscreen=no,toolbartranslucent=yes,closebuttoncolor=#000000,footer=no,closebuttoncaption=Fertig,lefttoright=yes,location=yes,presentationstyle=pagesheet,toolbarcolor=#FFFFFF,hidenavigationbuttons=yes,zoom=no");
      await Browser.open({ url: message.notification.data.url,  presentationStyle: "popover"});
    }
    if(message.action == "workout")
    {
      this.router.navigateByUrl("workout", {replaceUrl: true});
    }
  }

  public async onTokenRefresh() {
    try {
      if(this.platform.is("capacitor") || this.platform.is("cordova")) {
        await FirebaseMessaging.addListener('tokenReceived', event => {
          this.token = event.token;
          console.log('tokenReceived', { event });
        });
      }
      else {
        /*this.fireMessaging.tokenChanges.subscribe(
          (token) => {
            this.token = token!;
            console.log(`Got a new token ${token}`);
          },
          (error) => console.error("Error refreshing token", error)
        );*/
      }
    } catch (error) {
      console.error('Token refresh listener setup failed:', error);
    }
  }

  /*private async setBadgeNumber(value: number) {
    this.badge.set({count: value});
  }*/

  /*private async clearBadgeNumber() {
    if ('clearAppBadge' in navigator) {
      try {
        await (navigator as any).clearAppBadge();
      } catch (error) {
        console.error("Error clearing badge number", error);
      }
    } else {
      console.warn("clearAppBadge is not supported in this browser.");
    }
  }*/

  public async scheduleLocal(options: any)
  {
    //await this.requestPermission();
    if(this.platform.is("capacitor") && (await (LocalNotifications.checkPermissions())).display == "granted")
    {
      LocalNotifications.schedule(options);
    }
  }
}
